export const TASK_TYPE_CONFIG = {
  CARE_PLAN_REVIEW: {
    labelKey: 'tasks.MyDay.TaskItem.Types.CARE_PLAN_REVIEW',
    chipSx: {
      backgroundColor: '#E8F0FE',
      color: '#1E3A8A',
      borderColor: '#1E3A8A',
    },
  },
  CALL: {
    labelKey: 'tasks.MyDay.TaskItem.Types.CALL',
    chipSx: {
      backgroundColor: '#FEF3C7',
      color: '#92400E',
      borderColor: '#92400E',
    },
  },
  DEBRIEF: {
    labelKey: 'tasks.MyDay.TaskItem.Types.DEBRIEF',
    chipSx: {
      backgroundColor: '#E0E7FF',
      color: '#3730A3',
      borderColor: '#3730A3',
    },
  },
  APPROVAL: {
    labelKey: 'tasks.MyDay.TaskItem.Types.APPROVAL',
    chipSx: {
      backgroundColor: '#DCFCE7',
      color: '#166534',
      borderColor: '#166534',
    },
  },
  RESOLVE: {
    labelKey: 'tasks.MyDay.TaskItem.Types.RESOLVE',
    chipSx: {
      backgroundColor: '#FFE4E6',
      color: '#9F1239',
      borderColor: '#9F1239',
    },
  },
  REVIEW: {
    labelKey: 'tasks.MyDay.TaskItem.Types.REVIEW',
    chipSx: {
      backgroundColor: '#E0F2FE',
      color: '#075985',
      borderColor: '#075985',
    },
  },
  RESPOND: {
    labelKey: 'tasks.MyDay.TaskItem.Types.RESPOND',
    chipSx: {
      backgroundColor: '#F3E8FF',
      color: '#6B21A8',
      borderColor: '#6B21A8',
    },
  },
  NEW_CLIENT_LEAD: {
    labelKey: 'tasks.MyDay.TaskItem.Types.NEW_CLIENT_LEAD',
    chipSx: {
      backgroundColor: '#F3E8FF',
      color: '#6B21A8',
      borderColor: '#6B21A8',
    },
  },
  FOLLOW_UP: {
    labelKey: 'tasks.MyDay.TaskItem.Types.FOLLOW_UP',
    chipSx: {
      backgroundColor: '#E8F0FE',
      color: '#1E3A8A',
      borderColor: '#1E3A8A',
    },
  },
  UNKNOWN: {
    labelKey: null,
    chipSx: {
      backgroundColor: 'grey.300',
      color: 'grey.800',
      borderColor: 'grey.800',
    },
  },
};
